<h1 mat-dialog-title>Share</h1>
<div mat-dialog-content>
	<ngx-qrcode [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" [value]="data.url" cssClass="bshadow"></ngx-qrcode>
	<br />
	<p>Have someone scan this code or open the link</p>
</div>
<div mat-dialog-actions layout-align="center center">
	<button [disableRipple]="true" cdkCopyToClipboard="{{ data.url }}" mat-button (click)="onClick()">Share Link</button>
</div>
